export const Color = {
    primary : "#0059FF"
}